<script>
import ProductGroupItem from './ProductGroupItem';
import { productListMethods, productListComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods } from "@/state/helpers";
import Swal from "sweetalert2";
import ImageUpload from '@/components/ImageUpload';
import { required } from "vuelidate/lib/validators";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Product group component
 */
export default {
  page: {
    title: "Product Category"
  },
  data() {
    return {
      title: "Product Category",
      folder: 'product-groups',
      pagination: {
        rows: 12,
        page: 1,
        keyword: '',
        field: 'name',
        sort: 'name',
        orderDesc: false,
      },
      pageOptions: [12, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      groupLogo: {
        filename: null,
        type: null,
        base64: null
      },
      editModal: false,
      createModal: false,
      productGroupItem: {
        id: null,
        groupName: '',
        groupImageSrc: ''
      },
      formExitChecker: {
        id: null,
        groupName: '',
        groupImageSrc: ''
      },
      searchValue: {
        keyword: "",
      },
      searchOptions: [
        { text: 'Product Group', value: 'name' },
      ],
      lookupParams: {
        field: 'name',
      },
      sortOrderOptions: [
        { text: 'ASC', value: false },
        { text: 'DESC', value: true }
      ],
      orderFieldOptions: [
        { text: 'Product Group', value: 'name' },
      ],
      oldKeyword: '',
      submitted: false,
      productCategoryModule: {
        access: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      }
    };
  },
  validations: {
    productGroupItem: {
      groupName  : {required},
    },
  },
  components: {
    ProductGroupItem,
    ImageUpload
  },
  computed: {
    ...productListComputed,
    ...erpFixMessages
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,...exportMethods,
    ...erpUserRolesMethods,
    async onExport(){
      var self = this;
      await this.onSearch().then(function(){
        console.log("check this:",self.groupTotalRows);
        if(self.groupTotalRows ==0 ){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = Object.assign(
            self.pagination, 
            self.lookupParams, 
            {
              module: 'product_categories',
              email: JSON.parse(localStorage.getItem('userData')).email
            });

          delete params.page;
          delete params.rows;
          
          self.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));        }
      });
    },
    refresh() {
      this.clearLogo();
      this.listProdGroups();
    },
    openCreateModal() {
      this.productGroupItem = {
        id: null,
        groupName: ''
      },
        this.clearLogo();
      this.createModal = true;
      this.formExitChecker = {
        id: null,
        groupName: ''
      }
    },
    listProdGroups() {
      this.onPageUpdate();
      // this.listProductGroups(this.pagination);
    },
    createProdGroup() {
      var groupObj = { ...this.productGroupItem };
      delete groupObj.id;

      if (this.groupLogo.base64) {
        var groupLogo = { ...this.groupLogo };
        groupLogo.folder = this.folder;

        this.uploadLogo(groupLogo)
          .then(imageKey => {
            groupObj = {
              ...groupObj,
              groupImageSrc: imageKey
            }

            this.create(groupObj);
          })
          .catch(err => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(groupObj);
      }
    },
    editProdGroup(productGroup) {
      if (!this.productCategoryModule.access.read && !this.productCategoryModule.access.upate) {
        Swal.fire(
          "Access Restricted",
          "Looks like your access is limited. Please contact your administrator.",
          "warning"
        );
      } else {
        this.editModal = true,
          this.productGroupItem = {
            id: productGroup.groupId,
            groupName: productGroup.groupName,
            groupImageSrc: productGroup.groupImageSrc
          }
        this.formExitChecker = {
          id: productGroup.groupId,
          groupName: productGroup.groupName,
          groupImageSrc: productGroup.groupImageSrc
        }
      }
    },
    saveProdGroup() {
      var groupObj = { ...this.productGroupItem };
      delete groupObj['groupImageSrc'];

      if (this.groupLogo.base64) {
        var groupLogo = { ...this.groupLogo };
        groupLogo.folder = this.folder;

        this.uploadLogo(groupLogo)
          .then(imageKey => {
            groupObj = {
              ...groupObj,
              groupImageSrc: imageKey
            }

            this.update(groupObj);
          })
          .catch(err => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(groupObj);
      }
    },
    deleteProdGroup(productGroup) {
      if (!this.productCategoryModule.access.delete) {
        Swal.fire(
          "Access Restricted",
          "You are not allowed to delete a Product Category.",
          "warning"
        );
      } else {
        if (productGroup.itemCount > 0) {
          Swal.fire("Deletion Not Allowed!", `${productGroup.groupName} is currently being used by some products. Deletion is not allowed.`, "error");
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: `Do you really want to delete the ${productGroup.groupName} This process cannot be undone!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, delete it!",
          }).then((result) => {
            if (result.value) {
              this.deleteProductGroup(productGroup.groupId)
                .then(() => {
                  Swal.fire("Successfully Deleted!", `${productGroup.groupName} has deleted.`, "success");
                  this.listProdGroups();
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire("Deletion Failed!", `${productGroup.groupName} was not deleted.`, "error");
                });
            }
          });
        }
      }
    },
    create(groupObj) {
      this.submitted = true
      this.$v.$touch();
      if (!this.$v.productGroupItem.$invalid){
        this.createProductGroup(groupObj)
        .then(() => {
          this.createModal = false;
          Swal.fire("Create Successful!", `${this.productGroupItem.groupName} has been created.`, "success");
          this.listProdGroups();
          this.clearLogo();
        })
        .catch((e) => {
          this.createModal = false;
          Swal.fire("Create Failed!", Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${this.productGroupItem.groupName} was not created.`, "error");
          this.clearLogo();
        });
      } else {
        console.log("test");
      }
      
    },
    update(groupObj) {
      this.$v.$touch();
      if (!this.$v.productGroupItem.$invalid){
        this.updateProductGroup(groupObj)
        .then(() => {
          this.editModal = false;
          Swal.fire("Update Successful!", `${groupObj.groupName} has been updated.`, "success");
          this.listProdGroups();
          this.clearLogo();
        })
        .catch((err) => {
          this.editModal = false;
          Swal.fire("Update Failed!", Object.prototype.hasOwnProperty.call(err, "message")? err.message : `${this.productGroupItem.groupName} was not update.`, "error");
          this.clearLogo();
        });
      }
    },
    clearLogo() {
      this.groupLogo = {
        filename: null,
        type: null,
        base64: null
      }
      this.clearSearch();
    },
    clearform() {
      this.productGroupItem = {
        id: null,
        groupName: '',
        groupImageSrc: ''
      },
        this.formExitChecker = {
          id: null,
          groupName: '',
          groupImageSrc: ''
        }
    },
    clearSearch() {
      this.searchValue = {
        keyword: ""
      }
    },
    async onSearch() {
      if (this.searchValue.keyword) {
        this.pagination.page = 1;
        this.searching = true
        this.oldKeyword = this.searchValue.keyword
        await this.searchProduct()
      } else {
        if (this.oldKeyword != '') {
          this.searching = true
          this.pagination.page = 1;
          this.oldKeyword = this.searchValue.keyword
          await this.searchProduct()
        }
        else {
          this.searching = false
          this.searchValue = {
            keyword: "",
          }
          await this.onPageUpdate();
        }
      }
    },
    async searchProduct() {
      var filter = Object.assign(this.pagination, this.lookupParams);
      var params = Object.assign(filter, this.searchValue);
      console.log(params);
      await this.listProductGroups(
        params
      )
    },
    async onPageUpdate() {
      if (this.searching) {
        await this.searchProduct()
      } else {
        await this.listProductGroups(this.pagination)
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    leaveform(modal = 'add') {
      console.log(this.productGroupItem, this.formExitChecker);
      if (JSON.stringify(this.productGroupItem) == JSON.stringify(this.formExitChecker)) {
        if (modal == 'add') {
          this.createModal = false;
        } else if (modal == 'edit') {
          this.editModal = false;
        }
        this.clearform();
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        text: "you want to leave this page?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '##804997',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          if (modal == 'add') {
            this.createModal = false;
          } else if (modal == 'edit') {
            this.editModal = false;
          }
          this.clearform();
        } else {
          return;
        }
      })
    }
  },
  async mounted() {
    this.listProdGroups();
    this.changeTitle({ title: 'Product Category' });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'Product Template', to: { name: 'Product' } },
        { text: 'Product Category', to: { name: 'Product Group' } }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Product Template', 'Product Category')
        .then((access) => this.productCategoryModule.access = access);
    
  }
}

</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{ groupTotalRows }}</span> Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-8 col-sm-8">
                <div class="d-flex justify-content-lg-end mb-lg-3">
                  <template>
                    <div class="me-2">
                      <b-button v-if="productCategoryModule.access.create" @click="openCreateModal" variant="primary"><i class="uil uil-plus me-1"></i> Add Product
                        Category</b-button>
                    </div>
                  </template>

                  <a class="btn btn-secondary" @click="refresh">
                    <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                  </a>
                </div>
              </div>
              <div class="d-flex flex-wrap mt-3 mb-3">
                <div class="me-3 ta-right">
                  <b-form-group description="Search keyword">
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        v-model="lookupParams.field" :options="searchOptions"></b-form-select>
                      <b-form-input v-on:keyup.enter="onSearch" v-model="searchValue.keyword" class="rounded-0">
                      </b-form-input>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-3 w-350px ta-right">
                  <b-form-group description="Order by">
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" v-model="pagination.sort"
                        :options="orderFieldOptions"></b-form-select>
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none w-100px px-3"
                        v-model="pagination.orderDesc" :options="sortOrderOptions"></b-form-select>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-2">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onSearch" class="px-2">
                      <i class='bx bx-search bx-fw'></i>Search
                    </b-button>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                      <i class='uil uil-export me-1'></i> Export
                    </b-button>
                  </b-form-group>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- grid list -->
            <template>
              <div class="row">
                <product-group-item v-for="(productGroup, index) in productGroups" v-bind:key="index"
                  v-bind:productGroup="productGroup" @edit="editProdGroup(productGroup)"
                  @delete="deleteProdGroup(productGroup)" />
              </div>
              <!-- end row -->
            </template>
            <!-- end grid list -->`

            <div class="row g-0 text-center" v-if="groupTotalRows == 0">
              <span>No data to display.</span>
            </div>

            <div class="row g-0 text-center text-sm-start mt-3" v-if="groupTotalRows != 0 && groupTotalRows > 12">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit" id="display-record"
                            v-model="pagination.rows" :options="pageOptions" @change="listProdGroups"></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <!-- pagination -->
                      <b-pagination class="pagination-rounded" v-model="pagination.page" @input="listProdGroups"
                        :total-rows="groupTotalRows" :per-page="pagination.rows"></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- Modals -->
    <!-- create modal -->
      <b-modal
        id="modalAddProductGroup"
        title="Add Product Category"
        size="md"
        centered
        hide-footer
        hide-header-close
        v-model="createModal"
      >
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form class="px-4 py-3" @submit.prevent="handleSubmit(createProdGroup)" @@reset.prevent="reset">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label class="form-label small fw-bold">Business Category<span style="color: red">*</span></label>
                  <validation-provider name="Category name" rules="required" v-slot="validationContext">
                    <b-form-input
                      type="text"
                      class="form-control"
                      id="addcontact-name-input"
                      v-model="productGroupItem.groupName"
                      placeholder="Enter Product Category"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
                <div class="col-md-12 mb-3">
                 <image-upload v-model="groupLogo" label="Category Image" :isRequired="true" />  
                </div>
              </div>

              <div class="text-end mt-3">
                <b-button
                  variant="light"
                  class="w-sm"
                  type="button"
                  @click="leaveform()"
                  >Close</b-button
                >
                <b-button 
                  variant="primary" 
                  class="w-sm ms-2"
                  type="submit"
                  >Save</b-button
                >
              </div>
            </b-form>
          </ValidationObserver>
      </b-modal>
   
    <!-- end create modal -->
    <!-- edit modal -->
    <b-modal
      id="modalEditProductGroup" 
      title="Edit Product Category" 
      size="md" 
      centered 
      hide-footer 
      hide-header-close
      v-model="editModal"
      >
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form class="px-4 py-3" @submit.prevent="handleSubmit(saveProdGroup)" @@reset.prevent="reset">
              <div class="row">
                <label v-if="!productCategoryModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a product category.</label>
                <div class="col-md-12 mb-3">
                  <label class="form-label small fw-bold">Business Category<span style="color: red">*</span></label>
                  <validation-provider name="Category name" rules="required" v-slot="validationContext">
                    <b-form-input
                      type="text"
                      class="form-control"
                      id="addcontact-name-input"
                      v-model="productGroupItem.groupName"
                      placeholder="Enter Product Category"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
                <div class="col-md-12 mb-3">
                 <image-upload v-model="groupLogo" :imageSrc="productGroupItem.groupImageSrc" label="Category Image" :isRequired="true" />  
                </div>
              </div>

              <div class="text-end mt-3">
                <b-button
                  variant="light"
                  class="w-sm"
                  type="button"
                  @click="leaveform('edit')"
                  >Close</b-button
                >
                <b-button :disabled="!productCategoryModule.access.update"
                  variant="primary" 
                  class="w-sm ms-2"
                  type="submit"
                  >Save</b-button
                >
              </div>
            </b-form>
          </ValidationObserver>
      </b-modal>
    <!-- end edit modal -->
    <!-- End modals -->
  </div>
</template>
<style>
.m-200px {
  min-width: 150px;
}

.w-100px {
  width: 100px;
}
</style>